<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div style="margin: 0px 0px 8px 0px;">
    <span *ngFor="let marca of marcas" style="margin: 0px 16px 0px 2px;" [ngStyle]="{'color': marca.cor}">
      <i class="fa fa-square" aria-hidden="true"></i>
      {{marca.nome}}
    </span>
    <span translate style="margin: 0px 2px 0px 2px;" [ngStyle]="{'color': 'gray'}">
      <span class="badge badge-secondary">{{tiposUndefined.length}}</span> {{'parametros.tipoOS.marcaNaoDefinida'}}
    </span>
  </div>
  <div class="card" *ngFor="let categoria of categorias" style="margin-bottom: 6px;">
    <h5 [translate]="getTranslate(categoria.descricao)" class="card-header"></h5>
    <div class="card-body">
      <div class="card-text texto-translate">
        <p translate>
          {{'parametros.tipoOS.tiposSelecionadosOS'}}
        </p>
        <p [translate]="getTranslate(categoria.descricao)" class="ml-1"></p>
      </div>
      <div class="card-text">
        <div *ngFor="let tipo of categoria.tipos" class="d-inline-flex">
          <button class="btn btn-primary btn-sm" (click)="removerTipoCategoria(tipo.id, categoria.id)">
            {{tipo.tipo}}&nbsp;
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>&nbsp;
        </div>
      </div>
      <button translate type="button" (click)="showDialog(categoria.id)"
        class="btn btn-info mt-1">{{'parametros.tipoOS.adicionar'}}
      </button>
    </div>
  </div>
</div>

<p-dialog [(visible)]="display" [modal]=true [style]="{width: '40rem'}">
  <ng-template pTemplate="header">
    <div>
      <h5 translate class="modal-title">{{'parametros.tipoOS.adicionarTipoOS'}}</h5>
    </div>
  </ng-template>
  <ng-template pTemplate="body">
    <p translate>{{'parametros.tipoOS.SelecioneTipoOSAdicionarCategoria'}}</p>
    <div class="d-inline-flex" *ngFor="let tipo of tipos">
      <button class="btn btn-primary btn-sm itemListaSelecao m-1" pTooltip="{{tipo.descricao}}" tooltipPosition="top"
        (click)="adicionarTipoCategoria(tipo)">{{tipo.tipo}}&nbsp;
        <i class="fa fa-plus"></i>
      </button>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button translate type="button" class="btn btn-secondary" (click)="hideDialog()">Fechar</button>
  </ng-template>
</p-dialog>
